module.exports = __webpack_public_path__ + "static/media/Vestas logo_RGB_100.17cfff68.jpg";